import { type DataLayerCallbackProps } from '@dhl/datalayer'
import { type DataLayerData, type DataLayerEventEngagement, type DataLayerMeta } from '../types/types.js'
import { type AdobeEngagementInteractionEvent } from './types.js'
import { getDefaultMetaAttributes } from './getDefaultMetaAttributes.js'

export const writeEngagementEvent = (dataLayerEvent: DataLayerCallbackProps<DataLayerData, DataLayerMeta>): void => {
  const { engagement, funnel, content } = dataLayerEvent.meta as DataLayerEventEngagement

  const data: AdobeEngagementInteractionEvent = {
    event: 'dhl_utf_engagementInteraction',
    engagement,
    funnel,
    content: {
      ...content,
      attributes: {
        ...getDefaultMetaAttributes(dataLayerEvent.data),
        ...content?.attributes,
      },
    },
  }
  window.dataLayer?.push(data)
}
